/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface RescheduleConflictDto
 */
export interface RescheduleConflictDto {

    /**
     * The colliding session
     *
     * @type {JoinEntityDto}
     * @memberof RescheduleConflictDto
     */
    event: JoinEntityDto;

    /**
     * The therapy that session belongs to — possibly another one
     *
     * @type {JoinEntityDto}
     * @memberof RescheduleConflictDto
     */
    assignment: JoinEntityDto;

    /**
     * Title of the colliding session, for the message
     *
     * @type {string}
     * @memberof RescheduleConflictDto
     * @example Riabilitazione spalla — seduta 3
     */
    title: string;

    /**
     * ISO 8601
     *
     * @type {string}
     * @memberof RescheduleConflictDto
     */
    start: string;

    /**
     * ISO 8601; null for a session with no stored duration
     *
     * @type {string}
     * @memberof RescheduleConflictDto
     */
    end: string | null;
}
